// Module
var code = "<div data-ng-transclude></div>\n";
// Exports
var _module_exports = code;;
var path = 'template/component/widget/sidenav/vt-sidenav-body.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;